"use client";

import { useTranslations } from "use-intl";

import { SparkleIcon, type AppIcon } from "@/components/appIcons";
import { cn } from "@/lib/utils";
import type { DealOfferTag } from "@garimpa/lib/dealOfferTag";

type DealOfferTagPresentation = {
  Icon: AppIcon;
  labelKey: "superOffer";
  className: string;
};

const DEAL_OFFER_TAG_PRESENTATIONS = {
  super_offer: {
    Icon: SparkleIcon,
    labelKey: "superOffer",
    className: "border-amber-500/40 bg-amber-500/15 text-amber-700 dark:text-amber-300",
  },
} as const satisfies Record<DealOfferTag, DealOfferTagPresentation>;

function DealOfferTagChip({ tag }: { tag: DealOfferTag }) {
  const t = useTranslations("shared.affiliates");
  const presentation = DEAL_OFFER_TAG_PRESENTATIONS[tag];
  const TagIcon = presentation.Icon;

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-md border px-1.5 py-0.5 text-xs font-bold leading-none",
        presentation.className,
      )}
    >
      <TagIcon className="text-sm leading-none" />
      {t(presentation.labelKey)}
    </span>
  );
}

export function DealOfferTags({ tags }: { tags: DealOfferTag[] }) {
  return tags.map((tag) => <DealOfferTagChip key={tag} tag={tag} />);
}
